import wbImgS1 from '../images/service-single/web/1.jpg'
import wbImgS2 from '../images/service-single/web/2.jpg'
import wbImgS3 from '../images/service-single/web/3.jpg'

import apImgS1 from '../images/service-single/app/1.jpg'
import apImgS2 from '../images/service-single/app/2.jpg'
import apImgS3 from '../images/service-single/app/3.jpg'

import beImgS1 from '../images/service-single/backend/1.jpg'
import beImgS2 from '../images/service-single/backend/2.jpg'
import beImgS3 from '../images/service-single/backend/3.jpg'

import dbImgS1 from '../images/service-single/db/1.jpg'
import dbImgS2 from '../images/service-single/db/2.jpg'
import dbImgS3 from '../images/service-single/db/3.jpg'


const Services = [
    {
        "id": 1,
        "sTitle": "Web App Development",
        "shortDesc": "Crafting responsive and scalable web applications tailored to your business needs.",
        "description": "**Crafting responsive and scalable web applications** tailored to your business needs. Whether it's a simple landing page or a complex web platform, I ensure your application is visually appealing and functional.",
        "des2": "Using **modern frameworks like React, Angular, or Vue.js**, I build dynamic and interactive user interfaces. Every web app is optimized for performance, ensuring fast load times and smooth navigation.",
        "des3": "From **concept to deployment**, I handle the entire development lifecycle. My focus is on delivering secure, maintainable, and future-proof web applications that grow with your business.",
        "sImgS":wbImgS1,
        "ssImg1":wbImgS2,
        "ssImg2":wbImgS3,
        "icon":'flaticon-vector',
    },
    {
        "id": 2,
        "sTitle": "Mobile App Development",
        "shortDesc": "Creating visually stunning and highly functional mobile apps for iOS and Android platforms.",
        "description": "**Building intuitive mobile applications** for iOS and Android platforms. I create apps that are not only visually stunning but also highly functional and user-friendly.",
        "des2": "Leveraging **cross-platform frameworks like Flutter and React Native**, I ensure your app runs seamlessly on both iOS and Android. This approach saves time and resources while maintaining high-quality performance.",
        "des3": "I prioritize **user experience (UX) and performance optimization**, ensuring your app is fast, reliable, and easy to use. From prototyping to publishing on app stores, I handle every step of the process.",
        "sImgS":apImgS1,
        "ssImg1":apImgS2,
        "ssImg2":apImgS3,
        "icon":'flaticon-smartphone',
    },
    {
        "id": 3,
        "sTitle": "Backend API Development",
        "shortDesc": "Developing robust backend systems to power your applications with solid business logic.",
        "description": "**Developing powerful backend systems** that drive your applications. I specialize in creating robust server-side architectures that handle complex business logic and data processing.",
        "des2": "Using **Node.js, Python (Django/Flask), or Java (Spring Boot)**, I build scalable and secure APIs that integrate seamlessly with your frontend. My solutions are designed to handle high traffic and ensure data integrity.",
        "des3": "I focus on **performance, security, and scalability**, ensuring your backend can grow with your business. From authentication systems to third-party integrations, I deliver reliable and efficient solutions.",
        "sImgS":beImgS1,
        "ssImg1":beImgS2,
        "ssImg2":beImgS3,
        "icon":'flaticon-palette',
    },
    {
        "id": 4,
        "sTitle": "Database Management",
        "shortDesc": "Optimizing and managing databases for performance, reliability, and security.",
        "description": "**Optimizing and managing databases** for performance, reliability, and security. I design efficient database schemas that ensure your data is organized and easily accessible.",
        "des2": "Whether it's **SQL (MySQL, PostgreSQL) or NoSQL (MongoDB, Firebase)**, I work with the right database technology for your needs. I optimize queries, indexes, and storage to ensure fast and efficient data retrieval.",
        "des3": "I provide **ongoing database maintenance and support**, including backups, migrations, and performance tuning. My goal is to ensure your data is always secure, consistent, and available when you need it.",
        "sImgS":dbImgS1,
        "ssImg1":dbImgS2,
        "ssImg2":dbImgS3,
        "icon":'flaticon-bar-chart',
    },
];

export default Services;